module.exports = "/_next/static/images/4e56fd0c036d2d76c958c517d8c77e05-double-card@sm-2x.png.webp";